import {combineReducers} from "redux";
import FeedbackConst from "./FeedbackConst";

const timer = (state={timer:null}, action=null) => {
    switch(action.type){
        case FeedbackConst.START_TIMER:
            return Object.assign({},state,{timer: action.payload.timer});
        case FeedbackConst.START_DOWNLOAD:
            return state;
        default:
            return state;
    }
};

const fileGerman = (state={file:null, filename: null, mimeType: null}, action=null) => {
    switch(action.type){
        case FeedbackConst.RESULT_DOWNLOAD_FINISHED:
            if(!action.payload.hasOwnProperty("ready"))
                return Object.assign({}, state, {
                    file: action.payload.german.b64encodedFile,
                    filename: action.payload.german.fileName,
                    mimeType: action.payload.german.fileType
                });
            return state;
        default:
            return state;
    }
};

const fileEnglish = (state={file:null, filename: null, mimeType: null}, action=null) => {
    switch(action.type){
        case FeedbackConst.RESULT_DOWNLOAD_FINISHED:
            if(!action.payload.hasOwnProperty("ready"))
                return Object.assign({}, state, {
                    file: action.payload.english.b64encodedFile,
                    filename: action.payload.english.fileName,
                    mimeType: action.payload.english.fileType
                });
            return state;
        default:
            return state;
    }
};

const feedbackDownloadInfo = (state={interval: null, ready: false, fileNameEn:null, fileNameDe:null, fileSizeEn:null, fileSizeDe:null}, action=null) => {
    switch(action.type){
        case FeedbackConst.START_REQUESTS:
            return Object.assign({},state, {interval: action.payload.interval});
        case FeedbackConst.RESULT_DOWNLOAD_FINISHED:
            if(action.payload.ready === true){
                clearInterval(state.interval);
                return Object.assign({},state, {
                    ready: true,
                    fileSizeDe: action.payload.fileSizeDe,
                    fileSizeEn: action.payload.fileSizeEn,
                    fileNameDe: action.payload.fileNameDe,
                    fileNameEn: action.payload.fileNameEn
                })
            }
            return state;
        default:
            return state;
    }
};

const indicator = (state={interval: null, timer:0, circumference:0, strokeDashoffset:0, strokeDasharray:0, timespan:null}, action=null) => {
  switch(action.type){
    case "SET_INDICATOR_INITIAL":
      if(state.timer === 0 && state.interval == null)
        return Object.assign({}, state, {interval: action.payload.interval, timer: action.payload.timer, circumference: action.payload.circumference, strokeDashoffset: action.payload.strokeDashoffset, strokeDasharray: action.payload.strokeDashoffset, timespan:action.payload.timespan});
      else
        return state;
    case "SET_INDICATOR_TIMER":
      return Object.assign({}, state, {timer: action.payload.timer, strokeDashoffset: action.payload.strokeDashoffset});
    case "SET_INDICATOR_TICK":
      let offset = state.strokeDashoffset - ((state.circumference/state.timespan) * 50);
      if(state.timer === state.timespan || state.timer > state.timerspan)
        clearInterval(state.interval);
      return Object.assign({}, state, {strokeDashoffset: offset, timer: state.timer + 50});
    default:
      return state;
  }
};

const feedback = combineReducers({timer, fileGerman, fileEnglish, feedbackDownloadInfo, indicator});
export {feedback};



// WEBPACK FOOTER //
// ./src/modules/feedback/FeedbackReducer.js